module.exports = __webpack_public_path__ + "img/prj02.9cf07bc1.png";